import * as types from '@/constants/mutationTypes'

const state = {
  inboxPageToken: '',
  sentPageToken: '',
  draftPageToken: '',
  trashPageToken: '',
  savedPageToken: '',
  todoPageToken: ''
}
const getters = {
  inboxPageToken: state => state.inboxPageToken,
  sentPageToken: state => state.sentPageToken,
  draftPageToken: state => state.draftPageToken,
  trashPageToken: state => state.trashPageToken,
  savedPageToken: state => state.savedPageToken,
  todoPageToken: state => state.todoPageToken
}
const actions = {
  setInboxPageToken ({commit}, data) {
    commit(types.SET_INBOX_PAGE_TOKEN, {data})
  },
  setDraftPageToken ({commit}, data) {
    commit(types.SET_DRAFT_PAGE_TOKEN, {data})
  },
  setSentPageToken ({commit}, data) {
    commit(types.SET_SENT_PAGE_TOKEN, {data})
  },
  setTrashPageToken ({commit}, data) {
    commit(types.SET_TRASH_PAGE_TOKEN, {data})
  },
  setSavedPageToken ({commit}, data) {
    commit(types.SET_SAVED_PAGE_TOKEN, {data})
  },
  setTodoPageToken ({commit}, data) {
    commit(types.SET_TODO_PAGE_TOKEN, {data})
  }
}
const mutations = {
  [types.SET_INBOX_PAGE_TOKEN] (state, {data}) {
    state.inboxPageToken = data
  },
  [types.SET_DRAFT_PAGE_TOKEN] (state, {data}) {
    state.draftPageToken = data
  },
  [types.SET_SENT_PAGE_TOKEN] (state, {data}) {
    state.sentPageToken = data
  },
  [types.SET_TRASH_PAGE_TOKEN] (state, {data}) {
    state.trashPageToken = data
  },
  [types.SET_SAVED_PAGE_TOKEN] (state, {data}) {
    state.savedPageToken = data
  },
  [types.SET_TODO_PAGE_TOKEN] (state, {data}) {
    state.todoPageToken = data
  }}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/Email/modules/pageTokens.js